import React, { useState } from 'react';
import { FaWhatsapp, FaBars, FaTimes, FaPhone } from 'react-icons/fa';
import './Header.css';

const Header = ({ onOrderNow }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header className="header">
      <div className="container">
        <div className="header-content">
          {/* Logo */}
          <div className="logo">
            <div className="logo-main">
              <span className="logo-text">única</span>
              <span className="logo-accent">fácil</span>
            </div>
            <div className="logo-subtitle">DELIVERY OFICIAL</div>
          </div>

          {/* Desktop Navigation */}
          <nav className="nav-desktop">
            <a href="#precos" className="nav-link">Confira os Preços</a>
            <a href="#faq" className="nav-link">Perguntas Frequentes</a>
            <a href="#sobre" className="nav-link">Sobre</a>
            <a href="#contato" className="nav-link">Fale Conosco</a>
          </nav>

          {/* Contact Info - Desktop */}
          <div className="contact-info-desktop">
            <div className="delivery-status">
              <span className="status-text">111 entregas em andamento</span>
            </div>
            <div className="phone-info">
              <FaPhone className="phone-icon" />
              <span>Ligue agora</span>
              <span className="phone-number">4020.5278</span>
            </div>
            <button className="btn-primary" onClick={onOrderNow}>
              PEÇA AGORA
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button className="menu-toggle" onClick={toggleMenu}>
            {isMenuOpen ? <FaTimes /> : <FaBars />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="mobile-menu">
            <nav className="nav-mobile">
              <a href="#precos" className="nav-link" onClick={toggleMenu}>
                Confira os Preços
              </a>
              <a href="#faq" className="nav-link" onClick={toggleMenu}>
                Perguntas Frequentes
              </a>
              <a href="#sobre" className="nav-link" onClick={toggleMenu}>
                Sobre
              </a>
              <a href="#contato" className="nav-link" onClick={toggleMenu}>
                Fale Conosco
              </a>
            </nav>
            <div className="mobile-contact">
              <div className="phone-info">
                <FaPhone className="phone-icon" />
                <span>4020.5278</span>
              </div>
              <button className="btn-primary" onClick={() => {
                onOrderNow();
                toggleMenu();
              }}>
                PEÇA AGORA
              </button>
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
